<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">未对账单</div>
      <div class="title--button"></div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="titleData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <el-dialog
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      class="dialog"
      :title="'新增账单'"
      width="65%"
      @close="dialogClose"
    >
      <el-descriptions size="small" :column="1" border :label-style="labelStyle">
        <el-descriptions-item contentStyle="width: 220px">
          <template slot="label">对账单编号</template>
          <el-input
            style="width: 100%"
            v-model="dialogData.purchasesStatementDocNumber"
            placeholder="对账单编号"
            class="input"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 220px">
          <template slot="label">标题</template>
          <el-input
            style="width: 100%"
            v-model="dialogData.docName"
            placeholder="标题"
            class="input"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">全局搜索码</template>
          <el-input
            style="width: 100%"
            v-model="dialogData.globalSearchNumber"
            placeholder="全局搜索码"
            class="input"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">对账日期</template>
          <el-date-picker
            style="width: 100%"
            v-model="dialogData.baseStatementDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="对账日期"
          >
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">预付款日期</template>
          <el-date-picker
            style="width: 100%"
            v-model="dialogData.baseExpectedPaymentDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="预付款日期"
          >
          </el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
      <!-- 内容 -->
      <div>
        <myTable
          :maxHeight="420"
          :overflow="true"
          :id="'myTableOne'"
          :columnType="'columnIndex'"
          :list="changeList"
          :titleList="dialogTitleList"
          :tableBtnList="[]"
          @cellClickEvent="cellClickEvent"
          @inputNumberClick="inputNumberClick"
          ref="myTable"
        ></myTable>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="billOk()">确定</el-button>
        <el-button @click="dialogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selcetSetting,
  updateSetting,
  _debounce,
  subFloat,
  mulFloat,
  accAdd,
  year,
  month,
  day,
} from "@/utils/myUtils";

import {
  pmgtStatementPaymentDoc_getCooperativeSupplierStatementReceiptDocList,
  pmgtPurchasesStatementDoc_supplierGenerationPaymentStatementWithStatementPaymentDoc,
} from "@/api/myController/purchase";
export default {
  name: "reconciliation_unBill",
  props: {},
  components: {},
  data() {
    return {
      // *************主表状态
      labelStyle: {
        "text-align": "center",
        "font-weight": "600",
        width: "110px",
        "word-break": "keep-all",
      },
      // -------------------------
      dialogData: {},
      dialogState: {
        show1: false,
      },
      dialogTitleList: [
        {
          id: 0,
          name: "产品图片",
          value: "baseImgUrl",
          fixedState: false,
          isShow: true,
          dataType: "imageList",
          canEdit: false,
          width: 75,
        },
        {
          id: 0,
          name: "产品图纸",
          value: "baseDrawingFile",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 75,
        },
        {
          id: 0,
          name: "产品附件",
          value: "baseFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 75,
        },
        {
          id: 0,
          name: "入库单号", // 必传
          value: "baseAssociatedReceiptDocNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          width: 90,
        },
        {
          id: 2,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 90,
        },
        {
          id: 21,
          name: "产品规格",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 160,
        },
        {
          id: 7,
          name: "单位",
          value: "baseMaterialUnitName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 75,
        },
        {
          id: 3,
          name: "可对账数量",
          value: "baseSumMaterialAcountTotal",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          canEdit: false,
          width: 90,
        },
        {
          id: 4,
          name: "本次对账数量",
          value: "baseAmount",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          alwaysEditState: true,
          canEdit: true,
          width: 90,
        },
        {
          id: 8,
          name: "含税单价",
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          alwaysEditState: false,
          width: 75,
        },
        {
          id: 9,
          name: "未税单价",
          value: "baseMaterialUnitpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          alwaysEditState: false,
          width: 75,
        },
        {
          id: 5,
          name: "账单小计(含税)",
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 90,
        },
        {
          id: 61,
          name: "账单小计(未税)",
          value: "baseMaterialTotalpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 90,
        },

        {
          id: 10,
          name: "税率(%)",
          value: "baseTaxRate",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
          width: 90,
        },
      ],
      // ------------------------
      titleData: {},
      listQuery: {
        customerName: "", // 账户编号
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: "基本信息",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
        { name: "对账", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: [],
      // 表内容
      list: [],
      // 表头
      titleList: [
        {
          id: 1,
          name: "付款编号", // 必传
          value: "statementPaymentDocNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 1,
          name: "全局搜索码", // 必传
          value: "globalSearchNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 1,
          name: "标题", // 必传
          value: "docName", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
          width: 200,
        },
        {
          id: 1,
          name: "供应商名称", // 必传
          value: "baseSupplierName", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 0,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,

          sortable: true,
        },
        {
          id: 1,
          name: "产品规格", // 必传
          value: "specifications", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "textList", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 1,
          name: "产品单位", // 必传
          value: "baseMaterialUnitName", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 1,
          name: "对账数量", // 必传
          value: "baseSumMaterialAcountTotal", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "numberAccuracy", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
        },
      ],
      changeList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.list = [];
      this.changeList = [];
      pmgtStatementPaymentDoc_getCooperativeSupplierStatementReceiptDocList({
        orderParam: [this.orderParam],
        filter: this.titleData,
        modelType: 0,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = "V" + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = "---";
              }
            } catch (error) {}
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        case "对账":
          if (this.changeList.length == 0) {
            this.$message.error("请选择对账数据！");
          } else {
            this.dialogData.baseStatementDate = year() + "-" + month() + "-" + day();
            this.dialogData.baseExpectedPaymentDate =
              year() + "-" + month() + "-" + day();
            this.dialogData.globalSearchNumber = "";
            this.changeList.forEach((item, index) => {
              item.baseAmount = item.baseSumMaterialAcountTotal;
              if (index === 0) {
                this.dialogData.globalSearchNumber += item.globalSearchNumber;
              } else {
                if (
                  !this.dialogData.globalSearchNumber.includes(item.globalSearchNumber)
                ) {
                  this.dialogData.globalSearchNumber += "," + item.globalSearchNumber;
                }
              }
            });
            this.dialogData.docName = "对账单-" + this.dialogData.globalSearchNumber;
            this.dialogState.show1 = true;
          }
          break;
        default:
          break;
      }
    },
    billOk() {
      this.dialogData.baseSupplierId = this.getUserInfo.supplierId;
      this.dialogData.baseSupplierName = this.getUserInfo.showName;
      // 计算总金额
      let sumMoney = 0;
      this.changeList.forEach((item) => {
        item.baseCurrency = "人民币";
        item.statusDoc = 0;
        item.statusInvoice = 0;
        item.statusPayment = 0;
        item.statusReconcile = 0;
        sumMoney = accAdd(sumMoney, item.baseMaterialTotalprice);
      });
      this.dialogData.baseShouldInvoiceAmount = sumMoney;
      this.dialogData.baseShouldInvoiceAmountDiscounted = sumMoney;
      this.dialogData.baseShouldPaymentAmount = sumMoney;
      this.dialogData.baseShouldPaymentAmountDiscounted = sumMoney;
      this.dialogData.valueUninvoicedAmount = sumMoney;
      this.dialogData.valueUnpaidAmount = sumMoney;
      this.dialogData.baseCurrency = "人民币";
      this.dialogData.modelType = 0;
      this.dialogData.baseDiscount = 100;
      let json = {
        pmgtPurchasesStatementDocDto: this.dialogData,
        statementPaymentDocList: this.changeList,
      };
      pmgtPurchasesStatementDoc_supplierGenerationPaymentStatementWithStatementPaymentDoc(
        json
      ).then((res) => {
        this.$message.success("操作成功！");
        this.dialogClose();
        this.getList();
      });
    },
    // 动态计算
    inputNumberClick(row, val) {
      switch (val) {
        case "baseAmount":
          row.baseMaterialTotalpriceUntaxed = mulFloat(
            row.baseAmount,
            row.baseMaterialUnitpriceUntaxed
          );
          row.baseMaterialTotalprice = mulFloat(
            row.baseAmount,
            row.baseMaterialUnitprice
          );
          break;
        default:
          break;
      }
    },
    dialogClose() {
      this.dialogState.show1 = false;
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "":
          break;

        default:
          break;
      }
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
        justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
